import React from "react";

export const Testimonials = (props) => {
  // Review images from S3 bucket in order: 7, 1, 2, 4, 3, 5, 6
  const reviewImages = [
    "https://artcake-gallery.s3.us-east-1.amazonaws.com/review-7.png",
    "https://artcake-gallery.s3.us-east-1.amazonaws.com/review-1.png",
    "https://artcake-gallery.s3.us-east-1.amazonaws.com/review-2.png",
    "https://artcake-gallery.s3.us-east-1.amazonaws.com/review-4.png",
    "https://artcake-gallery.s3.us-east-1.amazonaws.com/review-3.png",
    "https://artcake-gallery.s3.us-east-1.amazonaws.com/review-5.png",
    "https://artcake-gallery.s3.us-east-1.amazonaws.com/review-6.png",
  ];

  return (
    <div id="reviews">
      <div className="container">
        <div className="section-title text-center">
          <h2>Reviews</h2>
        </div>
        <div className="reviews-container">
          {reviewImages.map((imgSrc, i) => (
            <div key={`review-${i + 1}`} className="review-photo">
              <img src={imgSrc} alt={`Review ${i + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
